import {
    COMMON_ASSETS_REDUCER_KEY,
} from "./reducer";

const getValueFromStore = (state = {}, property) => state[COMMON_ASSETS_REDUCER_KEY][property];

export const getGoogleFonts = (state = {}) => getValueFromStore(state, "googleFonts");